import { __assign } from "tslib";
export function typeToConverterSet(converterSets) {
    return converterSets.reduce(function (result, converterSet) {
        var types = converterSet.types.reduce(function (typeResult, type) {
            var _a;
            return __assign(__assign({}, typeResult), (_a = {}, _a[type] = converterSet, _a));
        }, {});
        return __assign(__assign({}, result), types);
    }, {});
}
//# sourceMappingURL=utils.js.map